/*
 * blazingcard
 * version 4.5
 * http://www.blazingcard.com
 *
 * Copyright (c) 2021 Kellton Tech Pvt Ltd
 * Author Kellton Tech Pvt Ltd <support@blazingcard.com>
 * Licensed under the MIT license.
 */
import { Action } from '@ngrx/store';
import { type } from '../../shared/utility/utilityHelpers';
import { AddProductModel } from '../models/add-product.request.model';
import { AddStreamModel } from '../models/add-stream.request.model';
import { getStreamModel } from '../models/get-stream.request.modal';

export const ActionTypes = {

  GET_USERS: type('[stream] get users'),
  GET_USERS_SUCCESS: type('[stream] get users success'),
  GET_USERS_FAIL: type('[stream] get users fail'),

  GET_CATEGORIES_LIST: type('[List] Do Categorylist'),
  GET_CATEGORIES_LIST_SUCCESS: type('[List] Do Categorylist Success'),
  GET_CATEGORIES_LIST_FAIL: type('[List] Do Categorylist Fail'),

  ADD_PRODUCT: type('[stream] add product'),
  ADD_PRODUCT_SUCCESS: type('[stream] add product success'),
  ADD_PRODUCT_FAIL: type('[stream] add product fail'),

  ADD_STREAM: type('[stream] add stream'),
  ADD_STREAM_SUCCESS: type('[stream] add stream success'),
  ADD_STREAM_FAIL: type('[stream] add stream fail'),

  GET_STREAM_LIST: type('[List] Do Streamlist'),
  GET_STREAM_LIST_SUCCESS: type('[List] Do Streamlist Success'),
  GET_STREAM_LIST_FAIL: type('[List] Do Streamlist Fail')
};
export class GetUsers implements Action {
  type = ActionTypes.GET_USERS;

  constructor() {
  }
}

export class GetUsersSuccess implements Action {
  type = ActionTypes.GET_USERS_SUCCESS;

  constructor(public payload: any) {
  }
}
export class GetUsersFail implements Action {
  type = ActionTypes.GET_USERS_FAIL;

  constructor(public payload = null) { }
}

export class GetCategorylistAction implements Action {
  type = ActionTypes.GET_CATEGORIES_LIST;

  constructor() { }
}

export class GetCategorieslistSuccessAction implements Action {
  type = ActionTypes.GET_CATEGORIES_LIST_SUCCESS;

  constructor(public payload: any) { }
}

export class GetCategorieslistFailAction implements Action {
  type = ActionTypes.GET_CATEGORIES_LIST_FAIL;

  constructor(public payload: any = null) { }
}

//add product action
export class AddProductAction implements Action {
  type = ActionTypes.ADD_PRODUCT;

  constructor(public payload: AddProductModel) { }
}

export class AddProductSuccessAction implements Action {
  type = ActionTypes.ADD_PRODUCT_SUCCESS;

  constructor(public payload: any) { }
}

export class AddProductFailAction implements Action {
  type = ActionTypes.ADD_PRODUCT_FAIL;

  constructor(public payload: any = null) { }
}

//add product action
export class AddStreamAction implements Action {
  type = ActionTypes.ADD_STREAM;

  constructor(public payload: AddStreamModel) { }
}

export class AddStreamSuccessAction implements Action {
  type = ActionTypes.ADD_STREAM_SUCCESS;

  constructor(public payload: any) { }
}

export class AddStreamFailAction implements Action {
  type = ActionTypes.ADD_STREAM_FAIL;

  constructor(public payload: any = null) { }
}

export class GetStreamlistAction implements Action {
  type = ActionTypes.GET_STREAM_LIST;

  constructor(public payload: getStreamModel) { }
}

export class GetStreamlistSuccessAction implements Action {
  type = ActionTypes.GET_STREAM_LIST_SUCCESS;

  constructor(public payload: any) { }
}

export class GetStreamlistFailAction implements Action {
  type = ActionTypes.GET_STREAM_LIST_FAIL;

  constructor(public payload: any = null) { }
}

export type Actions = 
            GetUsers 
            | GetUsersSuccess 
            | GetUsersFail
            | GetCategorylistAction
            | GetCategorieslistSuccessAction
            | GetCategorieslistFailAction
            | AddProductAction
            | AddProductSuccessAction
            | AddProductFailAction
            | AddStreamAction
            | AddStreamSuccessAction
            | AddStreamFailAction
            | GetStreamlistAction
            | GetStreamlistSuccessAction
            | GetStreamlistFailAction;
